import { Pill } from "@clipboard-health/ui-components";

interface ShiftBundlePillProps {
  shiftCount: number;
}

export function ShiftBundlePill(props: ShiftBundlePillProps) {
  const { shiftCount } = props;

  return (
    <Pill
      size="small"
      variant="filled"
      label={`${shiftCount}+ shift bundle`}
      iconType="block-shift"
      sx={{ width: "fit-content", background: (theme) => theme.palette.shift?.bundle?.gradient }}
    />
  );
}
